/** On-Pipe Configurator API base URL (include trailing slash). */
const explicitBase = process.env.REACT_APP_AWS_ON_PIPE_CONFIGURATOR_API ?? "";
const coilBase = process.env.REACT_APP_AWS_COIL_CONFIGURATOR_API ?? "";

/** When unset, derive from Coil URL by swapping the API mount path. */
const derivedFromCoil = coilBase.replace(
  /coil-configurator-api\/?$/i,
  "on-pipe-configurator-api/",
);

const rawBase = explicitBase || (derivedFromCoil !== coilBase ? derivedFromCoil : "");

export const axiosBaseURL = rawBase
  ? rawBase.endsWith("/")
    ? rawBase
    : `${rawBase}/`
  : "";

/**
 * Resource prefix — same pattern as Coil Configurator `/coilConfigurator`.
 * When BASE_URL already includes `/onPipeConfigurator`, paths are relative to that root.
 */
export const apiPathPrefix =
  axiosBaseURL && axiosBaseURL.includes("/onPipeConfigurator") ? "" : "onPipeConfigurator";

export const isOnPipeApiConfigured = () => Boolean(axiosBaseURL);
